export default __webpack_public_path__ + "static/media/FBLOG-logo.3cbd2373.png";